import { UntypedFormGroup } from "@angular/forms";
import { EntryConfigInterface, FormConfig, FormNavigationConfig } from "@ptl/forms";
import { County } from "@ptl/global-components";
import { PlanAttributes, SummaryView } from "../../../plan-selection/interfaces/plan-attributes.interface";
import { Product } from "../../../plan-selection/interfaces/product.interface";

export const EMPTY_DROPDOWN_OPTION = [{label: '', value: null}];

export interface DropdownOption {
    label: string;
    value: string|boolean|Product<PlanAttributes, SummaryView>;
}

export interface MassUploadEntryMap {
  [key: string]: MassUploadEntryConfig;
}

export interface MassUploadStateFormMap {
  stateId: number;
  formGroups: {[key: string]: UntypedFormGroup};
}

export interface MassUploadValueMap {
  excelValues: string[];
  jsonValue: any;
  displayValue: string;
}

export interface MassUploadRowAction {
  id: string;
  label: string;
  callback: Function;
}

export interface MassUploadRowData {
  rowData: string[];
  formPatchData?: any; // NOTE: this is FLATTENED entrycomponents oriented
}

export interface MassUploadAttributeConfig {
  gridIndex: number;
  editMode: boolean;
  firstTimeMassUploadCreate: boolean;
  actualComponentType?: string;
  errorColumn?: boolean;
  valueMapArray?: MassUploadValueMap[];
}

export interface MassUploadEntryConfig extends EntryConfigInterface {
    massUploadAttributes: {
        stateId?: number;
        editMode: boolean;
        actualComponentType?: string;
        statusColumn?: boolean;
        valueMapArray?: MassUploadValueMap[];
    }
}

export interface MassUploadGridConfiguration {
  formJsonToExcelMap: MassUploadExcelToJsonMap[];
  entryOverrides: MassUploadEntryConfig[];
}

export interface MassUploadExcelToJsonMap {
  index: number;
  excelHeading: string;
  formControlName: string; 
  customComponentType?: string;
  importToFormControl?: string;
  dependentField?: boolean;
  dependentField_SpouseOnly?: boolean; // dependentField MUST BE true when for this to have an effect
  valueMapArray?: any[];
  forceDisabled?: boolean;
  disableForRegions?: string[];
  errorMessages?: {[key:string]: string};
}

export interface MassUploadSpouseDependentValidations {
  minAge?: number;
  maxAge?: number;
  maxDependents?: number;
  minSmokingAge?: number;
  maxSpousalPartners?: number;
  medicareEligibleAge?: number;
  maxChildOnlyAge?: number;
}
  
export enum EXCEL_PERSON_TYPES {
  SUBSCRIBER = 'SUB',
  DEPENDENT = 'DEP',
  SPOUSE = 'SPOUSE',
  CHILD_ONLY = 'CHILD ONLY',
}

export enum PAYLOAD_PERSON_TYPES {
  SUBSCRIBER = 'SUBSCRIBER',
  DEPENDENT = 'DEPENDENT',
  SPOUSE = 'SPOUSE',
  CHILD_ONLY = 'CHILD ONLY',
}

// Form data must be formatted to the full, spelled out versions when saving and submitting
export const EXCEL_TO_PAYLOAD_MAP = {
  [EXCEL_PERSON_TYPES.SUBSCRIBER]: PAYLOAD_PERSON_TYPES.SUBSCRIBER,
  [EXCEL_PERSON_TYPES.DEPENDENT]: PAYLOAD_PERSON_TYPES.DEPENDENT,
  [EXCEL_PERSON_TYPES.SPOUSE]: PAYLOAD_PERSON_TYPES.SPOUSE,
  [EXCEL_PERSON_TYPES.CHILD_ONLY]: PAYLOAD_PERSON_TYPES.CHILD_ONLY
}
export const PAYLOAD_TO_EXCEL_MAP = {
  [PAYLOAD_PERSON_TYPES.SUBSCRIBER]: EXCEL_PERSON_TYPES.SUBSCRIBER,
  [PAYLOAD_PERSON_TYPES.DEPENDENT]: EXCEL_PERSON_TYPES.DEPENDENT,
  [PAYLOAD_PERSON_TYPES.SPOUSE]: EXCEL_PERSON_TYPES.SPOUSE,
  [PAYLOAD_PERSON_TYPES.CHILD_ONLY]: EXCEL_PERSON_TYPES.CHILD_ONLY
}

export enum EXCEL_ENROLLMENT_TYPES {
  OEP = 'OEP',
  SEP = 'SEP'
}

export enum EXCEL_ROW_INDEX {
  ROW_NUMBER = 0,
  PERSON_TYPE = 1,
  ENROLLMENT_TYPE = 2
}